<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal,
  BButton,
  BAlert,
  BRow,
  BCol,
  BFormGroup,
  BFormCheckbox,
  AlertPlugin,
  BForm,
  BFormInput,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@core/utils/validations/validations';

export default {
  components: {
    BFormInput,
    BForm,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        transportadoraid: '',
        transportadoranome: '',
        transportadoranomeabrev: '',
        pais: {
          pais_nome: '',
        },
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validateForm() {
      this.$emit('ok', this.dataForm);
      this.$bvModal.hide(this.idModal);
    },
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="dataForm.isDefault || dataForm.transportadoranome === ''"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="12"
              md="6"
          >
            <b-form-group
                label="Codigo"
                label-for="transportadoraid"
            >
              <b-form-input
                  id="transportadoraid"
                  v-model="dataForm.transportadoraid"
                  disabled
              />
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              md="6"
          >
            <b-form-group
                label="Nome"
                label-for="transportadoranome"
            >
              <b-form-input
                  id="transportadoranome"
                  v-model="dataForm.transportadoranome"
                  type="text"
                  disabled
              />
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              md="6"
          >
            <b-form-group
                label="Nome Abreviado"
                label-for="transportadoranomeabrev"
            >
              <b-form-input
                  id="transportadoranomeabrev"
                  v-model="dataForm.transportadoranomeabrev"
                  type="text"
                  disabled
              />
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              md="6"
          >
            <b-form-group
                label="Pais"
                label-for="paisid"
            >
              <b-form-input
                  id="paisid"
                  v-model="dataForm.pais.pais_nome"
                  type="text"
                  disabled
              />
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              md="6"
          >
            <b-form-group
                label="Uf"
                label-for="ufid"
            >
              <b-form-input
                  id="ufid"
                  v-model="dataForm.uf.ufid"
                  type="text"
                  disabled
              />
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              md="6"
          >
            <b-form-group
                label="Estado"
                label-for="ufid"
            >
              <b-form-input
                  id="ufid"
                  v-model="dataForm.uf.uf_nome"
                  type="text"
                  disabled
              />
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              md="6"
          >
            <b-form-group
                label="Telefone"
                label-for="transportadoratelefone"
            >
              <b-form-input
                  id="transportadoratelefone"
                  v-model="dataForm.transportadoratelefone"
                  type="text"
                  disabled
              />
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              md="6"
          >
            <b-form-group
                label="Disponivel"
                label-for="transportadoradisponivel"
            >
              <b-form-checkbox
                  id="transportadoradisponivel"
                  v-model="dataForm.transportadoradisponivel"
                  type="text"
                  disabled
              />
            </b-form-group>
          </b-col>
<!--          <b-col-->
<!--              cols="12"-->
<!--              md="6"-->
<!--          >-->
<!--            <b-form-group-->
<!--                label="Cidade"-->
<!--                label-for="transportadoracidade"-->
<!--            >-->
<!--              <b-form-input-->
<!--                  id="transportadoracidade"-->
<!--                  v-model="dataForm.transportadoracidade"-->
<!--                  type="text"-->
<!--              />-->
<!--            </b-form-group>-->
<!--          </b-col>-->
<!--          <b-col-->
<!--              cols="12"-->
<!--              md="6"-->
<!--          >-->
<!--            <b-form-group-->
<!--                label="Cep"-->
<!--                label-for="transportadoracep"-->
<!--            >-->
<!--              <b-form-input-->
<!--                  id="transportadoracep"-->
<!--                  v-model="dataForm.transportadoracep"-->
<!--                  type="text"-->
<!--              />-->
<!--            </b-form-group>-->
<!--          </b-col>-->
<!--          <b-col-->
<!--              cols="12"-->
<!--              md="6"-->
<!--          >-->
<!--            <b-form-group-->
<!--                label="CNPJ"-->
<!--                label-for="transportadoracnpj"-->
<!--            >-->
<!--              <b-form-input-->
<!--                  id="transportadoracnpj"-->
<!--                  v-model="dataForm.transportadoracnpj"-->
<!--                  type="text"-->
<!--              />-->
<!--            </b-form-group>-->
<!--          </b-col>-->
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
